enum FitAssistantStatus {
  NoSelection = 'noselection',
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
  NoFit = 'nofit',
  RackMounting = 'rackmounting',
}

export default FitAssistantStatus;
